var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.93133 8.42291L8.99175 5.3625L8.21987 4.59062L5.93133 6.87916L4.79383 5.74166L4.02196 6.51354L5.93133 8.42291ZM6.50008 11.9167C5.24522 11.6007 4.20928 10.8807 3.39227 9.75677C2.57525 8.63281 2.16675 7.38472 2.16675 6.0125V2.70833L6.50008 1.08333L10.8334 2.70833V6.0125C10.8334 7.38472 10.4249 8.63281 9.60789 9.75677C8.79088 10.8807 7.75494 11.6007 6.50008 11.9167ZM6.50008 10.7792C7.43897 10.4812 8.21536 9.88541 8.82925 8.99166C9.44314 8.09791 9.75008 7.10486 9.75008 6.0125V3.45312L6.50008 2.23437L3.25008 3.45312V6.0125C3.25008 7.10486 3.55703 8.09791 4.17091 8.99166C4.7848 9.88541 5.56119 10.4812 6.50008 10.7792Z",
    fill: "#0F9918"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/shield.daf9db691c0f924c7924ac5d40f37db7.svg";
export { ForwardRef as ReactComponent };